import { render } from "./wfm-uuid.vue?vue&type=template&id=466b467d&scoped=true"
import script from "./wfm-uuid.vue?vue&type=script&lang=js"
export * from "./wfm-uuid.vue?vue&type=script&lang=js"

import "./wfm-uuid.vue?vue&type=style&index=0&id=466b467d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466b467d"]])

export default __exports__